import { Text } from '@mantine/core'
import React from 'react'

const NoDataAvailable = () =>
{
    return (
        <div>
            <Text color='var(--color-text)' w={'inherit'} h={400} size={20} style={{ display: 'grid', placeItems: 'center' }}>No Data Available</Text>
        </div>
    )
}

export default NoDataAvailable
